var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"spinning":_vm.spinning}},[_c('a-card',[_c('a-table',{staticClass:"components-table-demo-nested",attrs:{"columns":_vm.columns,"data-source":_vm.listData,"childrenColumnName":"subMenus"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }